<template>
  <!-- A <th> that sorts. Lives here rather than in each table so the arrow, the
       aria state and the three-state click behaviour exist once and cannot
       drift between the requirements list and the PR list. -->
  <th :class="thClass" :aria-sort="ariaSort">
    <button
      v-if="sortKey"
      type="button"
      class="group flex items-center gap-1 uppercase tracking-wide font-semibold
             text-[11px] text-gray-600 hover:text-gray-900"
      :title="`Sort by ${plainLabel}`"
      @click="$emit('sort', sortKey)"
    >
      <span :class="active ? 'text-gray-900' : ''"><slot /></span>
      <!-- The arrow is always rendered, transparent when inactive, so the label
           does not shift sideways when a column becomes the active sort. -->
      <span
        class="text-[9px] leading-none"
        :class="active ? 'text-gray-900' : 'text-transparent group-hover:text-gray-300'"
      >{{ active && direction === 'desc' ? '▼' : '▲' }}</span>
    </button>
    <span v-else><slot /></span>
  </th>
</template>

<script>
export default {
  name: 'HadesSortHeader',
  props: {
    // Null makes the header inert (the dot column has nothing to sort on).
    sortKey: { type: String, default: null },
    activeKey: { type: String, default: null },
    direction: { type: String, default: 'asc' },
    thClass: { type: String, required: true },
  },
  emits: ['sort'],
  computed: {
    active() {
      return !!this.sortKey && this.sortKey === this.activeKey;
    },
    // Screen readers announce the sort state from the th, not the button.
    ariaSort() {
      if (!this.active) return 'none';
      return this.direction === 'desc' ? 'descending' : 'ascending';
    },
    plainLabel() {
      // Slot text is not readable from script, so the title falls back to the
      // key humanised. Good enough for a tooltip; the visible label is the slot.
      return this.sortKey.replace(/_/g, ' ');
    },
  },
};
</script>
